<script context="module">
    import { uuid } from '../Database.svelte';
    import {writable} from "svelte/store";

    let modals = writable([]);

    export function addModal(component, props = {}) {
        return new Promise((resolve, reject) => {
            let modal = {
                component: component,
                props: props
            }

            modal.id = uuid();

            modal.props.saveAction = (data) => {
                closeModal(modal.id);
                resolve(data);
            };

            modal.props.cancelAction = () => {
                closeModal(modal.id);
                reject("cancel");
            };

            modal.props.deleteAction = () => {
                closeModal(modal.id);
                reject("delete");
            };

            modals.update(m => [...m, modal]);
        })
    }

    export function closeModal(id) {
        modals.update(m => m.filter((i) => i.id != id))
    }

    let zIndex = 999;
</script>

{#each $modals as modal, idx}
    <div style="z-index: {zIndex + idx}">
        <svelte:component
        this={modal.component}
        {...modal.props}
        />
    </div>
{/each}